import { Module } from 'cerebral'
import onShowTerms from './chains/onShowTerms'
import onCloseTerms from './chains/onCloseTerms'
import getStarted from './chains/getStarted'
import onPreviousFiles from './chains/onPreviousFiles'
import onNextFiles from './chains/onNextFiles'
import onHideStartPage from './chains/onHideStartPage'
import onShowStartPage from './chains/onShowStartPage'
import hideTreeMenu from './chains/hideTreeMenu'

export default Module(({ name, path, controller }) => {
  return {
    state: {
      startIndex: 0,
      showTerms: false,
      latest: true
    },
    signals: {
      onShowTerms,
      onCloseTerms,
      getStarted,
      onPreviousFiles,
      onNextFiles,
      onHideStartPage,
      onShowStartPage,
      hideTreeMenu
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/Startpage/index.js